(function () {
  'use strict';

  var FORM_SELECTOR = 'form[data-type="add-to-cart-form"].dog1-pdp-product-form';

  async function handleAddToCart(event) {
    event.preventDefault();
    var form = event.currentTarget;
    var submitButton = form.querySelector('button[type="submit"]:not([style*="display:none"])');

    // Kein Fetch bei deaktiviertem Button (OOS-State)
    if (submitButton && submitButton.disabled) return;

    if (submitButton) {
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.disabled = true;
      submitButton.dataset.originalText = submitButton.textContent.trim();
      submitButton.textContent = 'Wird hinzugefügt…';
    }

    try {
      var formData = new FormData(form);
      formData.set('sections', 'cart-ajax');

      var response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        var errorData = await response.json();
        throw new Error(errorData.description || 'Fehler beim Hinzufügen');
      }

      var item = await response.json();

      var cartResponse = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
      });
      var cart = await cartResponse.json();

      // Shotgun: verschiedene Event-Conventions für Cart-Drawer-Kompatibilität
      document.dispatchEvent(new CustomEvent('cart:added', { detail: { item: item, cart: cart }, bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { item: item, cart: cart }, bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart }, bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart: cart }, bubbles: true }));
      form.dispatchEvent(new CustomEvent('product:added', { detail: { item: item, cart: cart }, bubbles: true }));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, cart: cart }, bubbles: true }));

      document.body.classList.add('cart-just-updated');
      setTimeout(function () { document.body.classList.remove('cart-just-updated'); }, 100);


    } catch (error) {
      console.error('[DOG1 ATC] Error:', error);
      alert('Es gab einen Fehler beim Hinzufügen. Bitte versuche es erneut.');
    } finally {
      if (submitButton) {
        submitButton.removeAttribute('aria-busy');
        submitButton.disabled = false;
        if (submitButton.dataset.originalText) {
          submitButton.textContent = submitButton.dataset.originalText;
          delete submitButton.dataset.originalText;
        }
      }
    }
  }

  function init() {
    var forms = document.querySelectorAll(FORM_SELECTOR);
    forms.forEach(function (form) {
      if (form.dataset.dog1Initialized === 'true') return;
      form.dataset.dog1Initialized = 'true';
      form.addEventListener('submit', handleAddToCart);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
